// src/ScrollToTop.js
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const ScrollToTop = () => {
    const { pathname } = useLocation();

    useEffect(() => {
        document.getElementById('topo')?.scrollIntoView({ behavior: 'smooth' });
    }, [pathname]);

    return null;
};

export default ScrollToTop;